import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';
import { Action } from '@studiometa/ui';
import Select from './components/Select.js';
import Toast from './components/Toast/index.js';
import Video from './components/Video.js';
import Animations from './components/Animations/index.js';
import StellarX5s from './components/StellarX5s/index.js';
import { initLazyModelViewers } from './lazy-model-viewer.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Action,
      Shop,
      Sections,
      Animations,
      Select,
      Toast,
      Video,
      StellarX5s,
      VideoPlyr: (app) =>
        importWhenVisible(() => import('./components/VideoPlyr.js'), 'VideoPlyr', app),
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }
}

const appInstance = createApp(App, document.documentElement);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLazyModelViewers);
} else {
  initLazyModelViewers();
}

export default appInstance;
